import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Title = styled.h5`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const DateInfo = styled.span`
  font-size: 12px;
  text-align: center;
  font-weight: normal;
  color: ${ColorPalette.HEX.DimGray};
`;
